module.exports = ".map2 {\n  width: 400px !important;\n  height: 400px !important; }\n"